<template>
  <layoutContainer>
    <div class="chat-history">
      <div class="chat-history-title">
        <div class="title-text">
          预约单号：{{$route.query.number}}的聊天记录
        </div>
      </div>
      <div ref="chatContainerRef" class="chat-container">
        <div v-for="(mes,mesIndex) in messageData" :key="mesIndex">
          <div v-if="mes.currentUserSendFlag === 0" class="chat-item other">
            <div class="avatar-row-other-user">
              <el-avatar icon="el-icon-user-solid" :src="mes.headPicUrl"/>
              <div class="user-name">{{mes.name}}</div>
            </div>
            <div class="message-content-other-user">
              <el-image class="icon-top" :src="require('@/assets/consultingRoom/mesContentOther.png')"/>
              {{mes.content}}
            </div>
          </div>
          <div v-else class="chat-item current">
            <div class="avatar-row-current-user">
              <el-avatar icon="el-icon-user-solid" :src="mes.headPicUrl"/>
              <div class="user-name">{{mes.name}}</div>
            </div>
            <div class="message-content-current-user">
<!--              <el-image class="icon-top" :src="require('@/assets/consultingRoom/mesContentCurrent.png')"/>-->
              {{mes.content}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </layoutContainer>
</template>
<script>
import {messageList} from '@/api/consultingRoom'

export default {
  name: 'chatHistory',
  data() {
    return {
      messageData: [],

    }
  },
  mounted() {
    this.getMessageList()
  },
  methods: {
    getMessageList() {
      const params = {
        meetingId: this.$route.query.meetingId
      }
      messageList(params).then(res=>{
        if(res.code === 200) {
          this.messageData = res.data
        }
      })
    }
  }
}
</script>
<style lang="scss">
.chat-history {
  background: #FFFFFF;
  border-radius: 8px 8px 8px 8px;
  .chat-history-title{
    text-align: center;
    font-size: 30px;
    color: #999999;
    padding: 30px 0;
    display: flex;
    justify-content: center;
    .title-text{
      background-color: #F5F5F5;
      padding: 8px 48px;
      border-radius: 8px;
    }
  }
  .chat-container{
    padding: 16px 24px;
    flex-shrink: 0;
    overflow-y: auto;
    .other{
      text-align: left;
    }
    .current{
      text-align: left;
    }
    .chat-item{
      margin-bottom: 9px;
      .avatar-row-current-user,.avatar-row-other-user{
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 10px;
        .user-name{
          color: #999999;
          fong-size: 14px;
        }
      }
      .avatar-row-current-user{
        justify-content: flex-start;
      }
      .avatar-row-other-user{
        justify-content: flex-start;
      }
      .message-content-current-user,.message-content-other-user{
        border-radius: 12px 12px 12px 12px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 400;
        font-style: normal;
        text-transform: none;
        padding: 6px 12px;
        display: inline-block;
        margin-left: 40px;
        word-break: break-all;
      }
      .message-content-current-user{
        color: #FFFFFF;
        background: #5AD3CD;
        position: relative;
        text-align: left;
        .icon-top{
          width: 10px;
          height: 10px;
          position: absolute;
          top: -6px;
          right: 10px;
        }
      }
      .message-content-other-user{
        color: #000000;
        background: #F5F5F5;
        position: relative;
        text-align: left;
        .icon-top{
          width: 10px;
          height: 10px;
          position: absolute;
          top: -6px;
          left: 10px;
          color: #F5F5F5;
        }
      }
    }
  }
}
</style>
